<template>
  <public-layout>
    <section class="hero hero-header-1">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered">
            <div class="column">
              <p class="product-title">
                FunLearning.com
              </p>
              <p class="product-subtitle">
                Inspiring educational resource hub meets digital teacher’s assistant.
              </p>
              <p class="product-description">
                FunLearning.com is the online marketplace for early education solutions developed by the <a href="https://funacademy.fi/" target="_blank">Fun Academy</a>. Features a holistic kindergarten package, professional development for educators, easy-to-implement resources and innovative digital tools. Each item on this platform has been curated by our pedagogical experts and supports the Fun Learning approach. Designed to spark curiosity and instil a passion for learning in preschoolers.
              </p>
              <p class="product-cta">
                <Button :to="{ name: 'login' }" v-if="!isAuthenticated" size="large">Get Started for Free</Button>
                <a href="javascript:;" @click="moreInfo = !moreInfo" class="button button-large button-secondary">{{moreInfo?'Read Less':'Read More'}}</a>
              </p>
            </div>
            <div class="column is-narrow">
              <img class="product-image" src="/static/img/assets/about-us.jpg" alt="">
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="hero is-light section-description" v-if="moreInfo">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered has-text-centered">
            <div class="column">
              <p class="subsection-title">
                <!-- <strong>The best start in life for every child. Everywhere.</strong> -->
              </p>

              <h2 class="section-title"><strong>The best start in life for every child. Everywhere.</strong></h2>
              <p class="subsection-subtitle">
                <a href="https://funacademy.fi/" target="_blank">Fun Academy</a> is an early education company that provides pedagogical solutions based on the unique Fun learning approach.
                 We are based at the Aalto University Learning Center in Espoo, Finland.
                 <a href="https://funacademy.fi/" target="_blank">Fun Academy</a> is currently present in four continents.
              </p>
            </div>
          </div>

          <section-bullets :items="readMoreItems"></section-bullets>
        </div>
      </div>
    </section>

    <section class="hero section-services" :class="{ 'has-top-gray-hero': !moreInfo }">
      <div class="hero-body">
        <div class="container">
          <div class="columns" v-for="(solution, index) in solutions" :key="index">
            <div class="column is-two-thirds" :class="{ 'is-offset-one-third': index % 2 !== 0 }">
                <product-card :data="solution" :isReverse="index % 2 !== 0"></product-card>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section class="hero is-light section-testimonies">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered has-text-centered">
            <div class="column">
              <p>
                "With the Fun Learning approach, days in the daycare are much more FUN! Fun Learning pedagogy helps not only children,
                 but also teachers to develop and improve their motivation and work as well."
              </p>
              <small>Olli Kamunen<br><i>Fun Academy Trainer, Director of a Helsinki City Kindergarten and member of Finland Education Advisory Board.</i></small>
            </div>
          </div>
        </div>
      </div>
    </section>

  </public-layout>
</template>

<script>
import PublicLayout from '@/layouts/PublicLayout'
import SectionBullets from '@/components/SectionBullets'
import SectionContact from '@/components/SectionContact'
import ProductCard from '@/components/ProductCard'
import Button from '@/components/Button'

export default {
  name: 'about-us',

  components: {
    PublicLayout,
    SectionBullets,
    SectionContact,
    ProductCard,
    Button
  },

  computed: {
    isAuthenticated () {
      return this.$store.state.isAuthenticated
    }
  },

  created () {},

  data () {
    return {
      moreInfo: false,
      readMoreItems: [
        `We aim to bring the best early education to every child on the planet.`,
        `We are a multinational team of pedagogical and cross-industry experts with a shared passion for making learning fun!`,
        `We develop solutions for a truly international application and easily adaptable to local cultures, curricula and students’ needs.`,
        `We empower teachers to enable children to reach their full potential, so they can become whatever they want in life.`
      ],
      solutions: [
        {
          title: `Fun Learning Approach`,
          description: `A holistic approach to early education created by <a href="https://funacademy.fi/" target="_blank">Fun Academy</a>. Helps teachers to promote key life skills to children, and nurtures the passion for learning through play and exploration. Based on Finnish pedagogical expertise in combination with the best practices around the world.`,
          img: 'static/img/assets/about-us-1.png',
          to: { name: 'approach' }
        },
        {
          title: `Fun Learning Team`,
          description: 'We are Tuka, Maco, Waaba and Soca, tour guides for your next Fun Learning adventure. We embrace diversity, live on curiosity and love to explore. Let’s discover the joy of learning together!',
          img: 'static/img/assets/about-us-2.png',
          to: { name: 'team' }
        }
      ]
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/FLPage.vue